"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleMessageLocalizer = simpleMessageLocalizer;
exports.default = default_1;
const invariant_1 = __importDefault(require("../util/invariant"));
const configure_1 = __importDefault(require("../util/configure"));
const default_messages_1 = require("./default-messages");
function getMessage(messages, path) {
    let i;
    let node = messages;
    const length = path.length;
    for (i = 0; i < length - 1; i++) {
        node = node[path[i]];
        if (typeof node === 'undefined') {
            return undefined;
        }
    }
    return node[path[i]];
}
function simpleMessageLocalizer() {
    return {
        formatMessage(path, variables, locale) {
            (0, invariant_1.default)(typeof variables === 'undefined', 'default message localizer doesn\'t support variables');
            if (locale) {
                throw new Error('[adp-react-components] You are attempting to use a widget with a non-default locale.' +
                    'However there is no localizer set. Please configure a message localizer.');
            }
            if (typeof path === 'string') {
                path = path.split('/');
            }
            const message = getMessage(default_messages_1.defaultMessages, path);
            if (typeof message !== 'string') {
                throw new Error('Message not found: ' + path.join('/'));
            }
            return message;
        }
    };
}
function default_1() {
    const localizer = simpleMessageLocalizer();
    configure_1.default.setMessageLocalizer(localizer);
    return localizer;
}
//# sourceMappingURL=simple-message-localizer.js.map